import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDoctor } from "../context/DoctorContext";
import { Users, LogOut, Clock, Star, MapPin } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import docIcon from '../images/doctor_image.png'

const Dashboard = () => {
  const navigate = useNavigate();
  const { loading, error, doctors, fetchAllDoctors } = useDoctor();
  const { logout } = useAuth();

  useEffect(() => {
    fetchAllDoctors();
  }, []);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      logout();
      navigate("/login");
    }
  };

  const getDoctorImage = (gender) => {
    return gender === "Female"
      ? "https://img.freepik.com/free-vector/doctor-background-design_1270-62.jpg"
      : docIcon;
  };

  const getDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (val) => (val * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c).toFixed(1);
  };

  // Hardcoded user location (replace with actual user's location from context or GPS)
  const userLocation = { lat: 22.7196, long: 75.8577 };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-[#941339] shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Users className="h-8 w-8 text-white" />
              <span className="ml-2 text-xl font-semibold text-white">
                Admin Dashboard
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center text-white hover:text-gray-200"
            >
              <LogOut className="h-5 w-5 mr-2" />
              Logout
            </button>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-semibold text-gray-900 mb-6">
          Doctors Directory
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {doctors.map((doctor) => (

              <div
                key={doctor.id}
                onClick={() => navigate(`/doctor/${doctor.id}`)}
                className="bg-white rounded-xl shadow p-4 hover:shadow-lg transition cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={getDoctorImage(doctor?.gender)}
                    alt={doctor?.doctorName}
                    className="w-16 h-16 rounded-xl object-cover"
                  />
                  <div className="flex-1">
                    <h3 className="text-md font-semibold">
                      Dr. {doctor?.doctorName}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {doctor?.specialization}
                    </p>
                    <div className="flex items-center text-sm font-medium mt-1 text-[#8D1B3D]">
                      {doctor?.clinicName || "Unknown Clinic"}
                    </div>
                  </div>
                </div>

                <div className="mt-3 text-sm text-gray-700">
                  <div className="flex items-center gap-1 text-gray-600">
                    <Clock className="w-4 h-4" />
                    <span>9AM–11AM & 4PM–8PM</span>
                  </div>

                  <div className="mt-2 flex gap-1 text-xs font-semibold text-center">
                    {["S", "M", "T", "W", "T", "F", "S"].map((day, i) => (
                      <span
                        key={i}
                        className={`px-1.5 py-0.5 rounded-md ${i === 2
                            ? "bg-pink-600 text-white"
                            : "bg-gray-200 text-gray-500"
                          }`}
                      >
                        {day}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex justify-between items-center mt-4">
                  <div className="flex items-center gap-1 text-yellow-500 text-sm font-medium">
                    <Star className="w-4 h-4 fill-yellow-400 stroke-yellow-400" />
                    <span>{doctor?.averageRating?.toFixed(1) || "4.0"}</span>
                    <span className="text-gray-500 text-xs ml-1">
                      ({doctor?.reviewCount || 0} reviews)
                    </span>
                  </div>
                  <button className="text-white rounded-full p-1.5" style={{ backgroundColor: "#8D1B3D" }}>
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                    >
                      <path d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
